import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CssBaseline, CircularProgress, Container, Button, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import Api from '../../services/api';
import { AbilityContext } from '../../config/ability-context'
import * as componentActions from '../../redux/actions/automation';
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import AutomationList from './automation-list';

class AutomationV2 extends Component {

  constructor(props) {
    super(props);

    this.typingTimeout = null;
    const { userSession } = this.props;
    // Filtro por status ativo — 3 opcoes fixas. `id` vira valor da querystring (?active=)
    // no fetch; `''` (Todas) omite o param.
    this.activeFilterOptions = [
      { id: '', name: props.intl.formatMessage({ id: 'all' }) },
      { id: 'true', name: props.intl.formatMessage({ id: 'active' }) },
      { id: 'false', name: props.intl.formatMessage({ id: 'inactive' }) },
    ];

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      resultList: [],

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      searchValue: '',
      // Default: "Todas" (id vazio → query sem filtro)
      activeFilter: this.activeFilterOptions[0]
    };

    this.callSearch = this.callSearch.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page });
    this.getItens(page);
  }

  setPagination(count, page) {

    let totalPage = Math.ceil(count / 10);
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10) {
          this.setState({ pageStart: 1, pageEnd: count });
        } else {
          this.setState({ pageStart: 1, pageEnd: 10 });
        }
      } else {
        let pageStart = ((page - 1) * 10) + 1;



        if (count >= page * 10) {
          this.setState({ pageStart: pageStart, pageEnd: page * 10 });
        } else {
          this.setState({ pageStart: pageStart, pageEnd: count });
        }
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 });
    }

  }

  onFieldChange(event) {


    this.setState({ [event.target.name]: event.target.value, page: 1 });

  }

  callSearch() {
    if (this.state.searchValue != '') {
      this.getItens(this.state.page);
    }
  }

  async clearFields() {
    await this.setState({ searchValue: '', page: 1 })
    this.getItens(1);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload") {
      this.componentDidMount();
    }
  }

  componentDidMount() {
    this.getItens(1);
  }

  // Callback do SimpleAutoComplete (assinatura padrao: stateName, value).
  // Ao trocar o filtro, re-consulta ja na pagina 1.
  changeActiveFilter = (stateName, value) => {
    this.setState({ [stateName]: value || this.activeFilterOptions[0], page: 1 }, () => {
      this.getItens(1);
    });
  };

  getItens(page = 1) {
    this.setState({ loading: true });
    let url = `/automation?page=${page}`;
    // Filtro por status ativo — omite o param quando "Todas" (id vazio).
    const af = this.state.activeFilter;
    if (af && af.id !== '' && af.id !== undefined && af.id !== null) {
      url += `&active=${af.id}`;
    }

    Api.get(url)

      .then(result => {
        if (result.data.success) {
          let count = result.data.count;
          this.setState({ count: count });
          this.setPagination(count, page);

          // F5.10 — buckets separados por target_entity. Cada bucket tem 3 posicoes (1/2/3
          // = criacao/atualizacao/horario). API retorna lowercase (targetentity).
          // Fallback: automation legada sem targetentity cai como 'called' (compat).
          const isChat = (item) => (item.targetentity ?? "called").toLowerCase() === "chat";
          const resultData = result.data.data || [];

          const buckets = {
            called: [
              resultData.filter(i => !isChat(i) && i.automationtypeid == 1),
              resultData.filter(i => !isChat(i) && i.automationtypeid == 2),
              resultData.filter(i => !isChat(i) && i.automationtypeid == 3),
            ],
            chat: [
              resultData.filter(i =>  isChat(i) && i.automationtypeid == 1),
              resultData.filter(i =>  isChat(i) && i.automationtypeid == 2),
              resultData.filter(i =>  isChat(i) && i.automationtypeid == 3),
            ],
          };
          this.setState({ loading: false, resultList: buckets });
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
      .catch(err => {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(err);
      });
  };

  updateActiveAsync = (automationId, active) => {
    
    this.setState({ loading: true });
    let url = `/automation/active`;
    const dataUpdated = {
      id: automationId,
      active: active
    }
    this.setState({ loading: true });
    Api.put(url, dataUpdated)
      .then(result => {
        if (result.data) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: "Atualizado com sucesso!"
          });
          this.getItens(this.state.page);
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
      .catch(err => {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(err);
      });
  };

  deleteAsync = (id) => {
    this.setState({ loading: true });
    let url = `/automation/${id}`;
    Api.delete(url)
      .then(result => {
        if (result.data) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: "Deletado com sucesso!"
          });
          this.getItens(this.state.page);
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
      .catch(err => {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(err);
      });
  };

  cloneItemAsync = (id) => {
    this.setState({ loading: true });
    let url = `/automation/clone/${id}`;
    Api.post(url)
      .then(result => {
        if (result.data) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: "Clonado com sucesso!"
          });
          this.getItens(this.state.page);
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
      .catch(err => {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(err);
      });
  };

  getItemForUpdateAsync = (id) => {
    this.setState({ loading: true });
    let url = `/automation/${id}`;
    Api.get(url)
      .then(result => {
        if (result.data) {
          this.props.addCurrent(result.data.data);
          this.props.history.push(`/${this.props.match.params.lang}/automation-edit`);
        }
        else {
          const intl = this.props.intl;
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
      .catch(err => {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(err);
      });
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }
  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const intl = this.props.intl;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <AutomationList
                columns={[
                  { title: intl.formatMessage({ id: "id" }), field: 'id' },
                  { title: intl.formatMessage({ id: "name" }), field: 'name' },
                  { title: intl.formatMessage({ id: "url" }), field: 'url' },
                  { title: intl.formatMessage({ id: "access.token.field.name" }), field: 'accesstokenfieldname' },
                ]}
                data={this.state.resultList}
                deleteItem={this.deleteItem}
                match={this.props.match}
                history={this.props.history}
                updateActiveAsync={this.updateActiveAsync}
                deleteAsync={this.deleteAsync}
                cloneItemAsync={this.cloneItemAsync}
                getItemForUpdateAsync={this.getItemForUpdateAsync}
                activeFilterOptions={this.activeFilterOptions}
                activeFilter={this.state.activeFilter}
                changeActiveFilter={this.changeActiveFilter}
              />

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}
AutomationV2.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AutomationV2)));

AutomationV2.contextType = AbilityContext;